import { MicrosoftSSOButton } from '@/components/Views/Login/MicrosoftSSOButton/MicrosoftSSOButton';
import { TextInputField } from '@spotted-zebra-uk/ui-components';
import { useTranslation } from 'react-i18next';
import { OrLine } from '@/components/Elements/OrLine/OrLine';
import styles from './only-sso-login.module.scss';
import { LinkButton } from '@/components/Elements/LinkButton/LinkButton';

type OnlySSOLoginProps = {
  email: string;
  handleSignIn: () => void;
  restartSigninProcess: () => void;
};

export const OnlySSOLogin = ({
  email,
  handleSignIn,
  restartSigninProcess,
}: OnlySSOLoginProps) => {
  const { t } = useTranslation();
  return (
    <div>
      <TextInputField
        id="email"
        value={email}
        label={t('forms.email')}
        placeholder={t('forms.email')}
        disabled
        onChange={() => {}}
      />
      <MicrosoftSSOButton className={styles.ssoButton} onClick={handleSignIn} />
      <OrLine />
      <LinkButton
        text={t('login.restartSignin')}
        onClick={restartSigninProcess}
      />
    </div>
  );
};
